/**
 * ThemeContext - Re-export from centralized theme
 *
 * This file re-exports the centralized theme from @tonnie/design-tokens.
 * All theme management is now handled by the shared package.
 *
 * @example
 * ```tsx
 * import { ThemeProvider, useTheme } from '../contexts';
 *
 * // In App.tsx
 * <ThemeProvider appId="journey" enableSystem enableCustom>
 *   <App />
 * </ThemeProvider>
 *
 * // In components
 * const { theme, toggleTheme, isDark } = useTheme();
 * ```
 */

// Re-export everything from centralized theme
export {
  // Provider and Context
  ThemeProvider,
  ThemeContext,
  useTheme,
  useThemeMode,
  useIsDark,
  // Types
  type Theme,
  type ThemeMode,
  type IOrganizationTheme,
  type IOrganizationThemeColors,
  type IOrganizationThemeAssets,
  type IThemeContextValue,
  type IThemeProviderProps,
  // Utilities (for advanced usage)
  getSystemTheme,
  applyThemeClass,
  applyCustomColors,
  applyCustomAssets,
} from '@tonnie/design-tokens';
